module.exports = __webpack_public_path__ + "assets/svg/Icons/32/message-blue-1bbc11.svg";